import { fokaAxios } from 'app/fokaAxios'
import {
  filterToParam,
  getPhaseToParam,
  isReportSort,
  sortToParam,
} from 'features/dashboard/utils/dashboardUtils'
import { sortCreativeResponse } from '../../../features/creative/creativeUtil'

export default {
  getUserColumnPresets: domainType =>
    fokaAxios.get('/api/v2/dashboard/settings/custom-column', {
      params: {
        domainType,
        adType: 'PREMIUM_LINK',
      },
    }),
  deleteUserColumnPresets: id =>
    fokaAxios.delete(`/api/v2/dashboard/settings/custom-column/${id}`),
  saveUserColumnPresets: ({ name, domainType, columns }) =>
    fokaAxios.post('/api/v2/dashboard/settings/custom-column', {
      name,
      domainType,
      columns,
      adType: 'PREMIUM_LINK',
    }),
  updateUserColumnPresets: ({ id, name, domainType, columns }) =>
    fokaAxios.put(`/api/v2/dashboard/settings/custom-column/${id}`, {
      name,
      domainType,
      columns,
      adType: 'PREMIUM_LINK',
    }),

  getCampaign: id => fokaAxios.get(`/api/v2/dashboard/campaigns/${id}`),
  getAdGroup: id => fokaAxios.get(`/api/v2/dashboard/adgroups/${id}`),
  getKeyword: id => fokaAxios.get(`/api/v2/dashboard/keywords/${id}`),
  getCreative: async id => {
    const response = await fokaAxios.get(`/api/v2/dashboard/creatives/${id}`)
    return sortCreativeResponse(response)
  },

  getKeywordsQi: ids => fokaAxios.post('/api/v2/keywords/qi', { itemid: ids }),

  getCampaignOperation: campaignId =>
    fokaAxios.get('/api/v2/dashboard/campaigns/operation', {
      params: {
        campaignId,
      },
    }),
  getAdGroupOperation: adGroupId =>
    fokaAxios.get('/api/v2/dashboard/adgroups/operation', {
      params: {
        adGroupId,
      },
    }),

  getAccountChart: ({ from, to, period }) =>
    fokaAxios.get('/api/v2/dashboard/accounts/report/chart', {
      params: {
        from,
        to,
        period,
      },
    }),
  getCampaignChart: ({ id, from, to, period }) =>
    fokaAxios.get(`/api/v2/dashboard/campaigns/${id}/report/chart`, {
      params: {
        from,
        to,
        period,
      },
    }),
  getAdGroupChart: ({ id, from, to, period }) =>
    fokaAxios.get(`/api/v2/dashboard/adgroups/${id}/report/chart`, {
      params: {
        from,
        to,
        period,
      },
    }),
  getKeywordChart: ({ id, from, to, period }) =>
    fokaAxios.get(`/api/v2/dashboard/keywords/${id}/report/chart`, {
      params: {
        from,
        to,
        period,
      },
    }),
  getCreativeChart: ({ id, from, to, period }) =>
    fokaAxios.get(`/api/v2/dashboard/creatives/${id}/report/chart`, {
      params: {
        from,
        to,
        period,
      },
    }),
  getTotalCampaignChart: ({ from, to, filters, period }) =>
    fokaAxios.post(
      `/api/v2/dashboard/campaigns${
        filters.length > 0 ? '/filter' : ''
      }/report/chart/total`,
      {
        selectedIds: {},
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          period,
        },
      }
    ),
  getTotalAdGroupChart: ({ from, to, campaignIds, filters, period }) =>
    fokaAxios.post(
      `/api/v2/dashboard/adgroups${
        filters.length > 0 ? '/filter' : ''
      }/report/chart/total`,
      {
        selectedIds: {
          campaignIds,
        },
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          period,
        },
      }
    ),
  getTotalKeywordChart: ({
    from,
    to,
    campaignIds,
    adGroupIds,
    filters,
    period,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${
        filters.length > 0 ? '/filter' : ''
      }/report/chart/total`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          period,
        },
      }
    ),
  getTotalContentMatchingChart: ({
    from,
    to,
    campaignIds,
    adGroupIds,
    filters,
    period,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${
        filters.length > 0 ? '/filter' : ''
      }/report/mediaType/chart/total`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        mediaType: 'PREMIUM_LINK_CONTENT',
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          period,
        },
      }
    ),
  getTotalCreativeChart: ({
    from,
    to,
    campaignIds,
    adGroupIds,
    filters,
    period,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/creatives${
        filters.length > 0 ? '/filter' : ''
      }/report/chart/total`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          period,
        },
      }
    ),
  deleteCampaigns: ({ ids }) =>
    fokaAxios.delete('/api/v2/campaigns', {
      data: {
        ids,
      },
    }),
  patchCampaignsOn: ({ ids }) =>
    fokaAxios.patch('/api/v2/campaigns/on', { ids }),
  patchCampaignsOff: ({ ids }) =>
    fokaAxios.patch('/api/v2/campaigns/off', { ids }),
  deleteAdGroups: ({ ids }) =>
    fokaAxios.delete('/api/v2/adgroups', {
      data: {
        adGroupIds: ids,
      },
    }),
  patchAdGroupsOn: ({ ids }) =>
    fokaAxios.patch('/api/v2/adgroups/on', {
      adGroupIds: ids,
    }),
  patchAdGroupsOff: ({ ids }) =>
    fokaAxios.patch('/api/v2/adgroups/off', {
      adGroupIds: ids,
    }),
  deleteKeywords: ({ ids }) =>
    fokaAxios.delete('/api/v2/keywords', {
      data: {
        keywordIds: ids,
      },
    }),
  patchKeywordsOn: ({ ids }) =>
    fokaAxios.patch('/api/v2/keywords/on', {
      keywordIds: ids,
    }),
  patchKeywordsOff: ({ ids }) =>
    fokaAxios.patch('/api/v2/keywords/off', {
      keywordIds: ids,
    }),
  deleteCreativeLinks: ({ ids }) =>
    fokaAxios.delete('/api/v2/creativelinks', {
      data: {
        creativeLinkIds: ids,
      },
    }),
  patchCreativeLinksOn: ({ ids }) =>
    fokaAxios.patch('/api/v2/creativelinks/on', {
      creativeLinkIds: ids,
    }),
  patchCreativeLinksOff: ({ ids }) =>
    fokaAxios.patch('/api/v2/creativelinks/off', {
      creativeLinkIds: ids,
    }),

  patchKeywordsBiddingStrategy: commands =>
    fokaAxios.patch(`/api/v2/keywords/premiumlink/biddingstrategy`, {
      commands,
      adGroupIdFromKeyword: true,
    }),
  modifyLandingURL: commands =>
    fokaAxios.patch('/api/v2/keywords/premiumlink/landingurl', {
      commands,
      adGroupIdFromKeyword: true,
    }),

  getExposurePreview: ({ device, keyword, limit }) =>
    fokaAxios.get('/api/v2/keywords/exposurestatus', {
      params: {
        device,
        keyword,
        limit,
      },
    }),

  getCampaignTable: ({ from, to, page, sort, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/campaigns${filters.length > 0 ? '/filter' : ''}`,
      {
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          page,
          limit: 200,
          ...(!isReportSort(sort.name) && { sort: sortToParam(sort) }),
        },
      }
    ),
  getCampaignFilterOperation: ({ from, to, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/campaigns${
        filters.length > 0 ? '/filter/operation' : '/operation/total'
      }`,
      {
        selectedIds: {},
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  downloadCampaignTable: ({ dashboardColumns, from, to, sort, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/campaigns${
        filters.length > 0 ? '/filter' : ''
      }/download`,
      {
        dashboardColumns,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getCampaignTableReport: ({ ids, columns, from, to }) =>
    fokaAxios.post(
      '/api/v2/dashboard/campaigns/report',
      {
        ids,
        columns,
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getCampaignTableReportTotal: ({ from, to, columns, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/campaigns${
        filters.length > 0 ? '/filter' : ''
      }/report/total`,
      {
        selectedIds: {},
        columns,
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getAdGroupTable: ({ from, to, page, sort, campaignIds, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/adgroups${filters.length > 0 ? '/filter' : ''}`,
      {
        campaignIds,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          page,
          limit: 200,
          ...(!isReportSort(sort.name) && { sort: sortToParam(sort) }),
        },
      }
    ),
  getAdGroupFilterOperation: ({ from, to, campaignIds, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/adgroups${
        filters.length > 0 ? '/filter/operation' : '/operation/total'
      }`,
      {
        selectedIds: {
          campaignIds,
        },
        ...filterToParam(filters),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  downloadAdGroupTable: ({
    campaignIds,
    dashboardColumns,
    from,
    to,
    sort,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/adgroups${
        filters.length > 0 ? '/filter' : ''
      }/download`,
      {
        campaignIds,
        dashboardColumns,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getAdGroupTableReport: ({ ids, columns, from, to }) =>
    fokaAxios.post(
      '/api/v2/dashboard/adgroups/report',
      {
        ids,
        columns,
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getAdGroupTableReportTotal: ({ from, to, columns, campaignIds, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/adgroups${
        filters.length > 0 ? '/filter' : ''
      }/report/total`,
      {
        selectedIds: {
          campaignIds,
        },
        columns,
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getKeywordTable: ({
    from,
    to,
    page,
    sort,
    campaignIds,
    adGroupIds,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${filters.length > 0 ? '/filter' : ''}`,
      {
        campaignIds,
        adGroupIds,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          page,
          limit: 200,
          ...(!isReportSort(sort.name) && { sort: sortToParam(sort) }),
        },
      }
    ),
  getKeywordFilterOperation: ({ from, to, campaignIds, adGroupIds, filters }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${
        filters.length > 0 ? '/filter/operation' : '/operation/total'
      }`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        ...filterToParam(filters),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  downloadKeywordTable: ({
    includeQualityScore,
    campaignIds,
    adGroupIds,
    dashboardColumns,
    from,
    to,
    sort,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${
        filters.length > 0 ? '/filter' : ''
      }/download`,
      {
        campaignIds,
        adGroupIds,
        dashboardColumns,
        includeQualityScore,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getKeywordTableReport: ({ ids, columns, from, to }) =>
    fokaAxios.post(
      '/api/v2/dashboard/keywords/report',
      {
        ids,
        columns,
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getKeywordTableReportTotal: ({
    from,
    to,
    columns,
    campaignIds,
    adGroupIds,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${
        filters.length > 0 ? '/filter' : ''
      }/report/total`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        mediaType: 'PREMIUM_LINK_SEARCH',
        columns,
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getKeywordTableReportMediaType: ({
    from,
    to,
    columns,
    campaignIds,
    adGroupIds,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/keywords${
        filters.length > 0 ? '/filter' : ''
      }/report/mediaType`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        mediaType: 'PREMIUM_LINK_CONTENT',
        columns,
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getCreativeTable: ({
    from,
    to,
    page,
    sort,
    campaignIds,
    adGroupIds,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/creatives${filters.length > 0 ? '/filter' : ''}`,
      {
        campaignIds,
        adGroupIds,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
          page,
          limit: 200,
          ...(!isReportSort(sort.name) && { sort: sortToParam(sort) }),
        },
      }
    ),
  getCreativeFilterOperation: ({
    from,
    to,
    campaignIds,
    adGroupIds,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/creatives${
        filters.length > 0 ? '/filter/operation' : '/operation/total'
      }`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
          keywordIds: [],
          creativeLinkIds: [],
        },
        ...filterToParam(filters),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  downloadCreativeTable: ({
    campaignIds,
    adGroupIds,
    dashboardColumns,
    from,
    to,
    sort,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/creatives${
        filters.length > 0 ? '/filter' : ''
      }/download`,
      {
        campaignIds,
        adGroupIds,
        dashboardColumns,
        ...(isReportSort(sort.name) && { reportSort: sortToParam(sort) }),
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getCreativeTableReport: ({ ids, columns, from, to }) =>
    fokaAxios.post(
      '/api/v2/dashboard/creatives/report',
      {
        ids,
        columns,
      },
      {
        params: {
          from,
          to,
        },
      }
    ),
  getCreativeTableReportTotal: ({
    from,
    to,
    columns,
    campaignIds,
    adGroupIds,
    filters,
  }) =>
    fokaAxios.post(
      `/api/v2/dashboard/creatives${
        filters.length > 0 ? '/filter' : ''
      }/report/total`,
      {
        selectedIds: {
          campaignIds,
          adGroupIds,
        },
        columns,
        ...(filters.length > 0 && filterToParam(filters)),
      },
      {
        params: {
          from,
          to,
        },
      }
    ),

  getTreeCampaigns: (status, sort) =>
    fokaAxios.get('/api/v2/dashboard/lnb/campaigns', {
      params: {
        status,
        sort,
      },
    }),
  getTreeAdGroups: (campaignId, status) =>
    fokaAxios.get(`/api/v2/dashboard/lnb/campaigns/${campaignId}/details`, {
      params: {
        status,
      },
    }),

  getRestrictionAccount: () =>
    fokaAxios.get('/api/v2/restriction/adAccounts/DASHBOARD_V2/BLACK'),
  getFilterFeature: () =>
    fokaAxios.get(`/api/v2/features/filter?phase=${getPhaseToParam()}`),

  getSavedFilters: () => fokaAxios.get('/api/v2/dashboard/filters'),
  saveFilter: filter => fokaAxios.post('/api/v2/dashboard/filters', filter),
  deleteFilter: id => fokaAxios.delete(`/api/v2/dashboard/filters/${id}`),
  updateFilter: ({ id, filter }) =>
    fokaAxios.put(`/api/v2/dashboard/filters/${id}`, filter),

  getAccountOperation: () =>
    fokaAxios.get('/api/v2/dashboard/accounts/operation'),
}
